import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class KlaviyoFormTrigger extends UcoastEl {
	static htmlSelector = 'klaviyo-form-trigger'
	button?: HTMLButtonElement
	formId?: string
	onClickHandler = this.onClick.bind(this)

	override connectedCallback() {
		super.connectedCallback()
		this.button = q.os<HTMLButtonElement>('button', this)
		this.formId = this.getAttribute('data-form-id') ?? undefined
		this.button?.addEventListener('click', this.onClickHandler)
	}

	override disconnectedCallback() {
		super.disconnectedCallback()
		this.button?.removeEventListener('click', this.onClickHandler)
	}

	onClick() {
		if (!this.formId) return

		window._klOnsite = window._klOnsite || []
		window._klOnsite.push(['openForm', this.formId])
	}
}
